<template>
  <section class="privacy-agreement">
    <label class="checkbox">
      <input type="checkbox" v-model="isChecked" :value="true"/>
      <i></i>请勾选同意
    </label>
    <div class="title" @click.stop="openDialog">《法律声明及隐私权政策》</div>
    <category-content-dialog :show.sync="showDialog" category-code="PrivacyAgreement" @confirm="isChecked = true"/>
  </section>
</template>

<script>
import CategoryContentDialog from "@/components/categoryContentDialog";
export default {
  name: "privacyAgreement",
  components: {CategoryContentDialog},
  data() {
    return {
      isChecked: false,
      showDialog: false
    }
  },
  watch: {
    isChecked(newVal, oldVal){
      this.$emit("checked", newVal)
    }
  },
  methods: {
    openDialog(){
      this.showDialog = true
    }
  }
}
</script>

<style scoped>
.privacy-agreement {
  margin: 10px;
  display: flex;
  justify-content: flex-start;
}
.privacy-agreement .checkbox{
  width: auto;
}
.privacy-agreement .title {
  color: #0563d8;
  line-height: .8rem;
  font-size: .28rem;
}
</style>
